import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react';
import { WhatsNewContainer } from 'owa-whats-new';
import { logUsage } from 'owa-analytics';
import strings from 'owa-strings/owa-whatsnew-strings';

@observer
export default class WhatsNewPane extends React.Component<HeaderPaneProps, {}> {
    constructor(props: HeaderPaneProps) {
        super(props);
    }

    componentDidMount() {
        logUsage('whatsNewPaneOpened');
    }

    render() {
        return (
            <HeaderFlexPane
                title={strings.whatsNew_FlexPane_Title}
                content={<WhatsNewContainer />}
                onDismiss={() => {
                    this.props.onDismiss();
                }}
            />
        );
    }
}
